import moment from "moment"

/**
 * If the current date is between the min and max dates, return true, otherwise return false.
 * @param min - The minimum date to check against.
 * @param max - The end of the range.
 * @returns A boolean value.
 */
export const showInDateRange = (min, max) => {
    return moment(moment().format('YYYY-MM-DD')).isBetween(min, max, undefined, '[]')
}

export const slugify = (value) => {
    return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
}

export const productPath = (idArticulo, nombre) => {
    const slug = slugify(nombre)
    return slug ? `/producto/${idArticulo}/${slug}` : `/producto/${idArticulo}`
}